import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BurgerService {

  private _isOpen = false;

  constructor() {
  }

  /**
   * Access private var
   */
  get isOpen(): boolean {
    return this._isOpen;
  }

  /**
   * Open burger
   */
  public open() {
    if (!this._isOpen) {
      this._isOpen = true;
    }
  }

  /**
   * Close burger
   */
  public close() {
    if (this._isOpen) {
      this._isOpen = false;
    }
  }

  /**
   * Toggle burger
   */
  public toggle() {
    if (this._isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}
